import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ChangeAuthenticator } from '@boller002/auth';
import auth from '../auth';
import config from '../config';

const Account = () => {
  const [email, setEmail] = useState('');
  useEffect(() => { auth.getEmail().then(setEmail, () => {}); }, []);

  return (
    <Box sx={{ maxWidth: 640 }}>
      <Typography variant="h4" component="h1" gutterBottom>Account</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>Signed in as {email}</Typography>
      <ChangeAuthenticator auth={auth} appName={config.appName} />
    </Box>
  );
};

export default Account;
